/**
 * Parse JSON
 *
 * @param string
 * @param fallback
 * @returns {*}
 */
export const parseJSON = (string, fallback) => {
    try {
        return JSON.parse(string);
    } catch (error) {
        return fallback || error;
    }
};

export default parseJSON;
